import { translationLivechat_da } from "./translationLivechat.da";
import { defineBilingualTranslations } from "./translationTypes";
import { translationLivechat_en } from "./translationLivechat.en";

export const translationLivechat = defineBilingualTranslations({
  da: translationLivechat_da,
  en: translationLivechat_en,
});
